<template>
<div class="chapter">
<div class="inner_page">
<a id="page_iii">
<p class="subtitle1y">DIE WEHRMACHT IM KAMPF</p>
<h1 class="titley">THE BATTLE OF KORSUN-CHERKASSY</h1>
<p class="subtitley">The Encirclement and Breakout of Army Group South, 1944</p>
<p class="authory">NIKOLAUS VON VORMANN</p>
<p class="author1"><em class="italic">Translated by</em></p>
<p class="author1y">GEOFFREY BROOKS</p>
<p class="author1"><em class="italic">Series editor:</em></p>
<p class="author1y">MATTHIAS STROHN</p>
<p class="pub"><img alt="image" src="images/pub.jpg"/></p>
</a>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 02_Title.vue?75ac12c6